import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { DrawerModule } from "primeng/drawer";
import { VendorService } from "../../../../core/services/vendor.service";
import {
  AddressDto,
  AddVendorAddressRequestDto,
} from "../../../../core/models/vendor/summary/addVendorAddressRequestDto";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { ClientPurpose } from "../../../../shared/enums/clientPurpose";
import { AddVendorAddressInformation } from "../../../../core/models/vendor/addVendor/addVendorAddressInformation.model";
import { AddressInformation } from "../../../../core/models/shared/addressInformaion";
import { AddressComponent } from "../../../../shared/components/address/address.component";
import { City } from "../../../../core/models/client/addclient/cityList";
import { AddressCountryRegion } from "../../../../core/models/client/addclient/countryRegionList";
import { AddressCounty } from "../../../../core/models/client/addclient/countyList";
import { AddressState } from "../../../../core/models/client/addclient/stateList";
import { District } from "../../../../core/models/vendor/summary/districtList";
import { ZipCodeDetails } from "../../../../core/models/shared/zipCodeDetails";
import { Address } from "../../../../core/models/shared/address";
import { ButtonModule } from "primeng/button";

@UntilDestroy()
@Component({
  selector: "jni-add-address-information",
  templateUrl: "./add-address-information.component.html",
  styleUrls: ["./add-address-information.component.scss"],
  imports: [CommonModule, DrawerModule, AddressComponent, ButtonModule],
  providers: [],
})
export class AddAddressInformationComponent implements OnInit {
  @Input() display!: boolean;
  @Input() headingStatus = true;
  @Output() displayChange = new EventEmitter<boolean>();
  @Input() isPrimaryFieldStatus = true;
  @Input() addressObject!: Address;
  @Output() refreshSummary = new EventEmitter<boolean>();
  @Input() isFromVendorSummary = false;
  @Input() loggedInUserIsAdmin = false;

  isPrimaryOne = "1";
  isPrimaryZero = "0";
  createNewContact = "Create New";
  updateNewContact = "Edit Address Information";
  countryRegionIdD365 = "USA";
  countryRegionSelectedId = "";
  createNewAddress = "Create New";
  updateNewAddress = "Edit Address Information";
  stateSelectedId = "";
  vendorForm: FormGroup;
  zipSelectionCode = "";
  countryRegionList: AddressCountryRegion[] = [];
  zipList: ZipCodeDetails[] = [];
  districtList: District[] = [];
  cityList: City[] = [];
  countyList: AddressCounty[] = [];
  stateList: AddressState[] = [];
  addressValidationStatus = false;
  showSmallLoader = false;
  vendorStatusId = "";
  postingDate: Date = new Date();
  @Input()
  set vendorIdFromModal(value: string) {
    this.vendorStatusId = value;
  }

  constructor(
    private _toastrService: JniToastrService,
    private _formBuilder: FormBuilder,
    private _vendorService: VendorService,
    private _router: ActivatedRoute,
    private _addNewClientService: AddNewClientService,
    private _loaderService: LoaderService
  ) {
    this.vendorForm = this._formBuilder.group({
      addressInformation: this._formBuilder.group({
        countryRegionIdD365: ["", [Validators.required]],
        zipCodeD365: [""],
        districtNameD365: [""],
        postBoxD365: [""],
        cityD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        stateD365: [""],
        addressD365: [""],
        streetD365: [""],
        notes: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: [false],
        addressLocationNameD365: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        addressFormat: [""],
        validateAddress: [""],
        addressLocationNumberD365: [0],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
      }),
    });

    this._router.params.subscribe(params => {
      this.vendorStatusId = params["id"];
    });
  }

  onHide() {
    this.displayChange.emit(false);
  }

  ngOnInit(): void {
    if (this.addressObject && this.headingStatus !== true) {
      if (Object.keys(this.addressObject).length !== 0) {
        this.patchValueInAddressForm(this.addressObject);
        this.headingStatus = false;
        this.vendorForm.get("type")?.disable();
      }
    } else {
      this.vendorForm.get("type")?.enable();
    }
    this.getCountryRegionListData();
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  patchValueInAddressForm(addressObject: Address) {
    this.vendorForm.patchValue({
      addressInformation: {
        countryRegionIdD365: addressObject.countryRegionIdD365,
        zipCodeD365: addressObject.zipCodeD365,
        districtNameD365: addressObject.districtNameD365,
        postBoxD365: addressObject.postBoxD365,
        cityD365: addressObject.cityD365,
        countyD365: addressObject.countyD365,
        streetNumberD365: addressObject.streetNumberD365,
        stateD365: addressObject.stateD365,
        addressD365: addressObject.addressD365,
        streetD365: addressObject.streetD365,
        addressLocationNameD365: addressObject.addressLocationNameD365,
        buildingComplimentD365: addressObject.buildingComplimentD365,
        apartment_RUD365: addressObject.apartment_RUD365,
        isPrimaryD365: addressObject.isPrimaryD365
          ?.toLowerCase()
          .includes("yes")
          ? true
          : false,
        addressLocationNumberD365: parseInt(
          addressObject.locationNumberD365 ?? "0"
        ),
      },
    });

    this.countryRegionIdD365 = addressObject.countryRegionIdD365 ?? "";
  }

  convertAddressControllerName(addObject: AddressInformation) {
    const addressObject: AddressDto = {
      LocationNumber: addObject.addressLocationNumberD365.toString(),
      AddressLocationName: addObject.addressLocationNameD365.toString(),
      City: addObject.cityD365.toString(),
      Street: addObject.streetD365.toString(),
      StreetNumber: addObject.streetNumberD365.toString(),
      CountryRegionID: addObject.countryRegionIdD365.toString(),
      State: addObject.stateD365.toString(),
      ZipCode: addObject.zipCodeD365.toString(),
      County: addObject.countyD365.toString(),
      BuildingComplement: addObject.buildingComplimentD365.toString(),
      DistrictName: addObject.districtNameD365.toString(),
      PostBox: addObject.postBoxD365.toString(),
      melissaAddressKeyD365: addObject.melissaAddressKeyD365,
      IsPrimary: addObject.isPrimaryD365 === true ? 1 : 0,
      Purpose: parseInt(addObject.purposeD365),
      Message: "",
      Status: "",
      StatusCode: 0,
    };
    return addressObject;
  }

  onSubmit() {
    const addAddressDto =
      this.vendorForm.getRawValue() as AddVendorAddressInformation;
    this._loaderService.setLoaderState(true);
    if (addAddressDto.addressInformation.isPrimaryD365) {
      addAddressDto.addressInformation.isPrimaryD365 = "YES";
    } else {
      addAddressDto.addressInformation.isPrimaryD365 = "NO";
    }

    const convertedAddressObject = this.convertAddressControllerName(
      addAddressDto.addressInformation
    );

    const addressArray = [];
    addressArray.push(convertedAddressObject);

    const address: AddVendorAddressRequestDto = {
      AccountNumber: this.vendorStatusId,
      Addresses: addressArray,
    };

    if (this.headingStatus) {
      this._vendorService
        .addAddressInformationData(address)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() !== "success") {
              this._toastrService.error(
                "Error",
                res.message || "Error in adding address"
              );
            } else {
              this._toastrService.success(
                "Success",
                res.message || "Address added successfully"
              );
            }
            this.displayChange.emit(false);
            this.refreshSummary.emit();
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastrService.error(
              "Error",
              res.message || "Error adding Address"
            );
          },
        });
    } else {
      this._vendorService
        .updateAddressInformationData(address)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() !== "success") {
              this._toastrService.error(
                "Error",
                res.message || "Error in updating address"
              );
            } else {
              this._toastrService.success(
                "Success",
                res.message || "Address update successfully"
              );
            }
            this.displayChange.emit(false);
            this.refreshSummary.emit();
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastrService.error(
              "Error",
              res.message || "Error updating Address"
            );
          },
        });
    }
  }
}
